import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export async function exportToExcel(data: unknown[], fileName: string) {
  try {
    // Criar um novo workbook
    const workbook = new ExcelJS.Workbook();
    
    // Adicionar uma planilha
    const worksheet = workbook.addWorksheet("Dados");
    
    if (data.length > 0) {
      // Obter as chaves do primeiro objeto para criar os cabeçalhos
      const headers = Object.keys(data[0] as Record<string, unknown>);
      
      // Adicionar cabeçalhos
      worksheet.addRow(headers);
      
      // Adicionar dados
      data.forEach((item) => {
        const row = headers.map(header => (item as Record<string, unknown>)[header]);
        worksheet.addRow(row);
      });
      
      // Estilizar cabeçalhos
      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true };
      headerRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE0E0E0' }
      };
    }
    
    // Gerar buffer do arquivo
    const buffer = await workbook.xlsx.writeBuffer();
    
    // Criar blob e fazer download
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    
    saveAs(blob, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Erro ao exportar para Excel:", error);
  }
}
